export class CardStudentContact {
    CanPickUp: boolean;
    CellNumber: string;
    Contact_Name: string;
    Email: string;
    EmergencyNumber: string;
    EmergencySequenceNumber: number;
    Employer: string;
    HasCustody: boolean;
    HomeNumber: string;
    IsEmergency: boolean;
    IsGuardian: boolean;
    IsPrimary: boolean;
    IsRestricted: boolean;
    LastLogin: string;
    LivesWith: boolean;
    MailingAddressLine1: string;
    MailingAddressLine2: string;
    Mem_ID: number;
    PID_ID: number;
    ParentPortalAccess: boolean;
    PrimaryAddressLine1: string;
    PrimaryAddressLine2: string;
    Relationship: string;
    WorkNumber: string;
    HomeNumber2: string;
    IsEnableLeaveWithHousehold: boolean;
    // DTO Field for V9 //
    ParentType: string;
    Comment: string;
    IsHeader: boolean;
}
